const auth = {
    // Provider Login
    providerSignIn: 'Provider-Anmeldung',
    customerSignIn: 'Kundenanmeldung',
    errorSendingCode: 'Der Bestätigungscode konnte nicht gesendet werden. Bitte versuche es erneut.',
    accessDashboard: 'Zugriff auf Ihr API-Management-Dashboard',
    email: 'E-Mail',
    emailPlaceholder: 'sie@firma.com',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    sendingCode: 'Code wird gesendet...',
    continueWithEmail: 'Mit E-Mail fortfahren',
    orContinueWith: 'Oder fortfahren mit',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithGithub: 'Mit GitHub fortfahren',
    continueWithApple: 'Mit Apple fortfahren',
    continueWithMicrosoft: 'Mit Microsoft fortfahren',
    continueWithProvider: 'Mit {{provider}} fortfahren',
    magicLinkTab: 'Magic Link',
    passwordTab: 'Passwort',
    password: 'Passwort',
    passwordPlaceholder: 'Ihr Passwort',
    otpCodeOptional: 'Sicherheitscode (optional)',
    passwordSignIn: 'Mit Passwort anmelden',
    usePassword: 'Passwort verwenden',
    useSignInCode: 'Anmeldecode verwenden',
    passwordLoginDisabled: 'Die Passwort-Anmeldung ist für diesen Provider deaktiviert.',
    customerPasswordLoginDisabled: 'Die Passwort-Anmeldung ist für dieses Kundenportal deaktiviert.',
    invalidCredentials: 'Anmeldedaten ungültig.',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    forgotPassword: {
      title: 'Passwort setzen oder zurücksetzen',
      description: 'Gib die E-Mail-Adresse deines Provider-Kontos ein, damit wir dir einen Link zum Setzen oder Zurücksetzen deines Passworts senden können.',
      submit: 'Passwort-Link senden',
      submitting: 'Link wird gesendet...',
      success: 'Wenn ein Konto existiert, wurde ein Link zum Setzen oder Zurücksetzen des Passworts gesendet.',
      backToLogin: 'Zurück zum Login',
      cta: 'Passwort setzen oder zurücksetzen',
      error: 'Passwort-Link konnte nicht gesendet werden. Bitte versuche es erneut.',
    },
    resetPassword: {
      title: 'Neues Passwort festlegen',
      description: 'Lege ein neues Passwort fest, um dein Konto wiederherzustellen.',
      passwordLabel: 'Neues Passwort',
      confirmPasswordLabel: 'Neues Passwort bestätigen',
      confirmPasswordPlaceholder: 'Neues Passwort bestätigen',
      submit: 'Passwort zurücksetzen',
      submitting: 'Passwort wird zurückgesetzt...',
      success: 'Passwort erfolgreich zurückgesetzt.',
      backToLogin: 'Zurück zum Login',
      invalidLink: 'Ungültiger oder abgelaufener Reset-Link.',
      invalidToken: 'Ungültiger oder abgelaufener Reset-Token.',
      passwordMismatch: 'Passwörter stimmen nicht überein.',
      error: 'Passwort konnte nicht zurückgesetzt werden. Bitte versuche es erneut.',
    },
    passwordValidation: {
      minLength: 'Passwort muss mindestens {{count}} Zeichen lang sein.',
      mixed: 'Passwort muss Groß- und Kleinbuchstaben enthalten.',
      symbols: 'Passwort muss mindestens ein Symbol enthalten.',
      numbers: 'Passwort muss mindestens eine Zahl enthalten.',
    },
    passwordPolicy: {
      title: 'Passwortanforderungen',
      minLength: 'Mindestens {{count}} Zeichen.',
      requireNumbers: 'Mindestens eine Zahl.',
      requireSymbols: 'Mindestens ein Symbol.',
      requireMixedCase: 'Groß- und Kleinbuchstaben.',
      disallowPrevious: 'Die letzten {{count}} Passwörter dürfen nicht wiederverwendet werden.',
    },
    newToFlorentin: 'Neu hier?',
    oauthSigningIn: 'Anmeldung wird abgeschlossen',
    oauthPending: 'Anmeldung wird abgeschlossen...',
    oauthPendingWithProvider: 'Anmeldung mit {{provider}} wird abgeschlossen...',
    oauthAwaitingOnboarding: 'Fast geschafft – wählen Sie, wie Sie Florentin nutzen möchten.',
    oauthErrorTitle: 'Anmeldung fehlgeschlagen',
    oauthDenied: 'Autorisierung abgelehnt. Bitte versuchen Sie es erneut.',
    oauthMissingCode: 'Autorisierungscode fehlt. Bitte versuchen Sie es erneut.',
    oauthUnknownContext: 'Der Zielbereich der Anmeldung konnte nicht ermittelt werden.',
    oauthReturnToLogin: 'Zurück zur {{context}}-Anmeldung',
    socialRoleModal: {
      title: 'Account-Typ wählen',
      subtitle: 'Sagen Sie uns, wie Sie Florentin nutzen möchten, damit wir den richtigen Arbeitsbereich vorbereiten können.',
      lead: 'Wählen Sie den Account-Typ, den Sie erstellen',
      helper: 'Diese Angabe begleitet Ihre Social-Anmeldung, damit das Onboarding den passenden Workspace anlegt.',
      individual: {
        title: 'Ich melde mich als Einzelperson an',
        description: 'Perfekt für Solo-Maker mit persönlichen Automationen und Auswertungen.',
      },
      team: {
        title: 'Ich erstelle ein Team',
        description: 'Richten Sie einen gemeinsamen Workspace ein, laden Sie Kolleg:innen ein und verwalten Sie Plätze gemeinsam.',
        nameLabel: 'Teamname',
        namePlaceholder: 'Acme Automation',
        sizeLabel: 'Teamgröße (optional)',
        descriptionLabel: 'Team-Beschreibung (optional)',
        descriptionPlaceholder: 'Kurze Notiz, damit Kolleg:innen den Workspace erkennen.',
        descriptionHelper: 'Wir geben diese Metadaten an das Backend weiter, um das Onboarding zu beschleunigen.',
      },
      validation: {
        selectRole: 'Bitte wählen Sie vor dem Fortfahren, wie Sie Florentin nutzen möchten.',
        teamNameRequired: 'Bitte geben Sie einen Teamnamen an, damit wir den Workspace korrekt zuordnen können.',
      },
      cta: 'Weiter',
      ctaLoading: 'Weiterleitung…',
    },
    
    // Verify Page
    verifyEmail: 'E-Mail verifizieren',
    codeSentTo: 'Wir haben einen 6-stelligen Code an {{email}} gesendet',
    didntReceiveCode: 'Code nicht erhalten?',
    resendIn: 'Erneut senden in {{seconds}}s',
    resendCode: 'Code erneut senden',
    useDifferentEmail: 'Andere E-Mail verwenden',
    testingNote: 'Zum Testen verwenden Sie Code: 123456',
    incorrectCode: 'Der eingegebene Code ist falsch',
    emailVerification: {
      heading: 'Sichere E-Mail-Verifizierung',
      cardTitle: 'E-Mail-Verifizierung',
      verifying: 'Ihre E-Mail-Adresse wird verifiziert...',
      alreadyVerifiedTitle: 'E-Mail bereits verifiziert',
      successTitle: 'E-Mail erfolgreich verifiziert',
      alreadyVerifiedBody: 'Ihre E-Mail-Adresse wurde bereits verifiziert. Sie können sich anmelden.',
      successBody: 'Danke! Ihre E-Mail-Adresse ist bestätigt.',
      errorTitle: 'Wir konnten Ihre E-Mail nicht verifizieren',
      goToLogin: 'Zum Login',
      returnToLogin: 'Zurück zum Login',
      home: 'Startseite',
      backToHome: 'Zurück zur Startseite',
    },
  } as const;

export default auth;
